import { render, staticRenderFns } from "./PropertyTransactionListTable.vue?vue&type=template&id=68e78bc7&"
import script from "./PropertyTransactionListTable.vue?vue&type=script&lang=js&"
export * from "./PropertyTransactionListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports